import * as React from 'react'
import { useAssetDrop } from '@repo/studio-components-asset-drag/use-asset-drop'
import type { AssetMediaType } from '@repo/studio-components-asset-drag/asset'
import { openAidaOverlayFromElement } from '../stores/overlay-store'
import { useExternalAssetDropStore } from '../stores/external-asset-drop-store'
import { useAidaMediaDragAvailable } from './use-aida-media-drag-available'

const MEDIA_DROP: readonly AssetMediaType[] = ['image', 'video']

export function useAidaImageDrop() {
  const available = useAidaMediaDragAvailable()
  const originRef = React.useRef<HTMLDivElement>(null)
  const drop = useAssetDrop({
    accept: MEDIA_DROP,
    onDrop(asset) {
      useExternalAssetDropStore.getState().enqueue(asset)
      if (originRef.current) {
        openAidaOverlayFromElement(originRef.current)
      }
    },
  })
  return { originRef, available, ...drop }
}
